import * as THREE from 'three';

export const createRaycaster = () => {
  return new THREE.Raycaster();
};